import React, { useContext, useState } from "react";
import { useActions, useData, useFormField } from "state/hooks";
import { change } from "state/actions/data";
import SelectList, { SelectListItem } from "playground/ui/SelectList";
import { targetDevices } from "config/devices";
import EntityContext from "containers/context/EntityContext";
import { create } from "state/actions/create";
import uuid from "uuid/v4";
import DeviceSelectList from "playground/cms/fields/Media/DeviceSelectList";
//import PropTypes from 'prop-types';

export function ContextMenu(props) {
    const { type, id, onEditMediaSet, onMenuClose } = props;

    const [deviceSelect, setDeviceSelect] = useState(false);
    const { value, onChange: onChangeField } = useFormField("media");

    const root = useContext(EntityContext);
    const [rootType, rootId] = root.split("/");

    const { embed, target_device, type: mediaType } = useData(props);
    const { onChange, onCreate } = useActions({
        onChange: change,
        onCreate: create,
    });
    const toggleEmbed = (e) => {
        //e.stopPropagation();
        onChange(type, id, { embed: !embed });
        onChange(rootType, rootId, {});
    };
    const setTargetDevice = (e, device) => {
        //e.stopPropagation();
        onChange(type, id, { target_device: device });
        onChange(rootType, rootId, {});
    };
    const setDeviceSelectEvt = (e, value) => {
        e.stopPropagation();
        setDeviceSelect(value);
    };
    const createMediaSet = () => {
        const newMedia = {
            id: uuid(),
            type: "mediaset",
            media_set: [
                {
                    id: uuid(),
                    media: [id],
                },
            ],
        };
        onCreate(type, newMedia);
        onChangeField(
            value.map((mediaId) => {
                return mediaId === id ? newMedia.id : mediaId;
            })
        );
        onEditMediaSet(newMedia.id);
    };

    if (deviceSelect) {
        return (
            <DeviceSelectList
                onMenuClose={onMenuClose}
                onChange={setTargetDevice}
                value={target_device}
            />
        );
    }

    return (
        <>
            <SelectList onClick={onMenuClose}>
                <SelectListItem onClick={toggleEmbed}>
                    {embed ? "Enable embed" : "Disable embed"}
                </SelectListItem>
                <SelectListItem onClick={(e) => setDeviceSelectEvt(e, true)}>
                    {targetDevices[target_device] || "Select target device"}
                </SelectListItem>
                {mediaType !== "mediaset" ? (
                    <SelectListItem onClick={() => createMediaSet(id)}>
                        Create media set
                    </SelectListItem>
                ) : (
                    <SelectListItem onClick={() => onEditMediaSet(id)}>
                        Edit media set
                    </SelectListItem>
                )}
            </SelectList>
        </>
    );
}

ContextMenu.propTypes = {};

ContextMenu.defaultProps = {};

export default ContextMenu;
